"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonMainCategoriesDesktop = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _times = _interopRequireDefault(require("es-toolkit/compat/times"));
var _styles = require("../../BurgerMenu/Links/styles");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const SkeletonMenuLinks = (0, _mui.styled)(_styles.LinksRoot)(({
  theme
}) => ({
  display: 'grid',
  gap: theme.spacing(1),
  padding: theme.spacing(0, 2)
}));
const CATEGORIES_LINKS = 20;
const SkeletonMainCategoriesDesktop = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SkeletonMenuLinks, {
    "data-testid": getTestId(_constants.MAIN_CATEGORY_DESKTOP),
    children: (0, _times.default)(CATEGORIES_LINKS, index => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
      animation: "wave",
      height: 45,
      variant: "rectangular"
    }, `menu-main-links-${index}`))
  });
};
exports.SkeletonMainCategoriesDesktop = SkeletonMainCategoriesDesktop;
